import {
	AUTENTIA_FOCUS,
	OUTOUT_AUTENTIA_FIELDS,
	VERIFY_AUTENTIA_URL,
} from "../libraries/constants";
import { publicInstance, SERVER_API } from "./http";

const getToken = async () => {
	try {
		const res = await publicInstance.get(`${SERVER_API}acepta/token`);
		const { data } = res;
		return data;
	} catch (err) {}
};

const validateToken = async (token) => {
	try {
		const res = await publicInstance.get(
			`${SERVER_API}acepta/validate-token?token=${token}`,
		);
		const { data } = res;
		return data;
	} catch (err) {}
};

const proccessResponse = (resolve) => (response) => {
	console.log("processResponse", response.toString());

	const { token, ParamsGet } = response;
	const data = validateToken(token)
		? ParamsGet
		: {
				error: "invalid Acepta token",
			};
	resolve(data);
};

const login = async (rut, callback) => {
	const { token } = await getToken();
        debugger;
	localStorage.setItem("acepta-token", token);
	window.Autentia.IniciarSesion(rut, token, proccessResponse(callback));
};

const logout = async () => {
	const token = localStorage.getItem("acepta-token");
	await window.Autentia.CerrarSesion(token);
};

const getContributions = async (rut, authorizationCode) => {
	const json = {
		rut,
		authorizationCode,
	};

	console.log("Previred Code", JSON.stringify(json));

	try {
		const res = await publicInstance.post(
			`${SERVER_API}previred`,
			JSON.stringify(json),
		);
		const { data } = await res;
		return data;
	} catch (err) {
		console.err("Error in previred service", JSON.stringify(err));
		const {
			response: { data },
		} = await err;

		throw data;
	}
};

const verify = async (rut, callback) => {
	let { token } = await getToken();
	token += "12312";
	const data = {
		pRut: rut,
	};
	window.Autentia.Transaccion2(
		VERIFY_AUTENTIA_URL,
		data,
		OUTOUT_AUTENTIA_FIELDS,
		AUTENTIA_FOCUS,
		token,
		proccessResponse(callback),
	);
};

const FootPrintService = {
	login,
	logout,
	verify,
	getContributions,
};

export default FootPrintService;
